import React from 'react';

import SrText from 'client/components/SrText';

const SrTextGreycliff = (props) => {
  return <SrText font="greycliff" {...props} />;
};

SrTextGreycliff.displayName = 'SrTextGreycliff';
SrTextGreycliff.propTypes = SrText.propTypes;

export default SrTextGreycliff;
